// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__CBHVL","signup":"Profile_signup__liXj4"};